/* eslint-disable tailwindcss/no-custom-classname */

import { usePopoverContext, usePopoverStyles } from '@chakra-ui/react';
import { callAllHandlers } from '@chakra-ui/utils';
import classnames from 'classnames';
import type { MouseEvent } from 'react';
import React from 'react';

import { withChakraAs } from '../../utils/withChakraAs';
import type { CloseButtonProps } from '../CloseButton/CloseButton';
import { CloseButton } from '../CloseButton/CloseButton';

export type PopoverCloseButtonProps = Omit<CloseButtonProps, 'size'>;

export const PopoverCloseButton = withChakraAs<
  PopoverCloseButtonProps,
  'button'
>(({ onClick, className, ...props }: CloseButtonProps) => {
  const { onClose } = usePopoverContext();
  const styles = usePopoverStyles();

  return (
    <CloseButton
      variant="hidden"
      {...props}
      className={classnames('chakra-popover__close-btn', className)}
      size="sm"
      onClick={callAllHandlers(
        onClick,
        (event: MouseEvent<HTMLButtonElement>) => {
          event.stopPropagation();
          onClose();
        },
      )}
      sx={styles.closeButton}
    />
  );
});
